<template>
  <b-card>
    <b-card-header>
      <i class="icon-menu mr-1"></i>User Detail
    </b-card-header>
    <User :id="$route.params.id"/>
    <h5>Own devices</h5>
    <Devices :ownedBy="$route.params.id"/>
    <h5>Logs</h5>
    <Logs :userId="$route.params.id"/>    
    <template slot="footer">
      <b-button @click="goBack">Back</b-button>
    </template>
  </b-card>
</template>

<script>
import User from '../users/User'
import Devices from '../devices/Devices'
import Logs from '../logs/Logs'

export default {
  name: 'UserDetail',
  components: {
      User,
      Devices,
      Logs
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
